import {ListViewProvider, useListView} from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider' 
import { QueryResponseProvider } from './core/QueryResponseProvider'

import {ListHeader} from './components/header/ListHeader'
import {MyTable} from './table/MyTable'
import { EditModal } from './edit-modal/EditModal' 
import { KTCard } from '../../../../../../_metronic/helpers' 

const DealerList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <MyTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <EditModal />}
    </>
  )
}

const DealerListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <DealerList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {DealerListWrapper}
